// JST (UTC+9) ユーティリティ（フロントエンド用）
// new Date().toISOString() はUTC基準になるため、JST日付が必要な場合はこれを使う。

export function todayJst(): string {
  return new Date(Date.now() + 9 * 60 * 60 * 1000).toISOString().slice(0, 10)
}

export function thisMonthJst(): string {
  return todayJst().slice(0, 7)
}

/** JST基準で n ヶ月後（負数で過去）の YYYY-MM を返す */
export function shiftMonthJst(base: string, delta: number): string {
  const [y, m] = base.split('-').map(Number)
  const d = new Date(y, m - 1 + delta, 1)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
}
